<script>
// import axios from "axios";
import router from "@/router";

import {
  required,
  email
} from "vuelidate/lib/validators";

export default {
  page: {
    title: "Volunteer System",
    meta: [
      {
        name: "Volunteer System",
      },
    ],
  },
  props:['modelType'],
  components: {  },
  data(){
    return{
      title: "",
      items: [
        {
          text: "",
          href: "/",
        },
      ],
      createAccount: {
        email: "",
        password: ""
      },
      typeSubmit:false
    }
  },
  validations: {
    signInForm: {
      email: { required, email },
      password: { required }
    },
  },
  methods: {
    contactInfo(modelType) {
      router.push({ name: 'contact-info', params: { modelType: modelType }})
    },
    signIn() {
      this.typeSubmit = true;
      // stop here if form is invalid
      this.$v.$touch()
    },
  },
}
</script>

<template>
  <div>
    <div class="card">
      {{modelType}}
      <div class="card-body py-5">

        <div class="text-center mt-3">
            <h5 class="card-title mb-5">Create Account to Begin Application</h5>
        </div>
        <form @submit.prevent="signIn" >


          <div class="mb-3">
            <label>Email Address</label>
            <input
                v-model="createAccount.email"
                type="text"
                class="form-control"
                placeholder="Enter Email Address"
                name="email"
                :class="{
                    'is-invalid': typeSubmit && $v.createAccount.email.$error,
                  }"
            />
            <div
                v-if="typeSubmit && $v.createAccount.email.$error"
                class="invalid-feedback">
              <span v-if="!$v.createAccount.email.required">Email is required.</span>
              <span v-if="!$v.createAccount.email.email">Invalid email.</span>
            </div>
          </div>

          <div class="mb-3">
            <label>Enter Password</label>
            <input
                v-model="createAccount.password"
                type="password"
                class="form-control"
                placeholder="********"
                name="password"
                :class="{
                    'is-invalid': typeSubmit && $v.createAccount.password.$error,
                  }"
            />
            <div
                v-if="typeSubmit && $v.createAccount.password.$error"
                class="invalid-feedback">
              <span v-if="!$v.createAccount.password.required"
              >Password is required.</span>
            </div>
          </div>

          <div class="mb-0">
            <div class="text-center">
              <button @click="contactInfo(modelType)" type="submit" class="btn btn-primary">
                Sign In</button>
            </div>
          </div>

        </form>

      </div>
    </div>
  </div>

</template>
<style scoped>
.card{
  position: absolute;
  top: 50%;
  left: 0px;
  right: 0px;
  width: 600px;
  margin: 0 auto;
  transform: translateY(-50%);
}
</style>
